import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../fixedAssetLedgerSlice";
import { fetchFixedAssetLedger } from "../fixedAssetLedgerThunk";
import { fetchFixedAssetAccs } from "../../../../store/commonThunks/lookups";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";

const FixedAssetLedgerFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.fixedAssetLedger);
  const { fixedAssetAccs = [], loading } = useSelector(
    (state) => state.lookups
  );

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    dispatch(fetchFixedAssetAccs());
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.accId) {
      messageApi.warning("Select Account");
      return;
    }
    dispatch(fetchFixedAssetLedger(filters)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      {/* <Row gutter={16} align="middle"> */}
      <Row
        gutter={[16, 16]}
        align="middle"
        wrap
        style={{ alignItems: "center" }}
      >
        <Col xs={24} sm={12} md={4} lg={6} xl={4} style={{paddingTop:"8px"}}>
          <label>Account</label>
          <SearchListAutoComplete
            style={{ width: "100%" }}
            optionsList={(fixedAssetAccs || []).map((acc) => ({
              sale_id: acc.acc_id,
              display_text: acc.acc_name,
            }))}
            onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("accId", null);
                return;
              } 
              handleFilterChange("accId", obj?.sale_id);
            }}
            placeholder="Fixed Asset Account"
            loading={loading.fixedAssetAccs}
            showAddNew={false}
          />
        </Col>

        {/* <RecordDateFilter
          filters={filters}
          handleFilterChange={handleFilterChange}
        /> */}

        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
          handleFilterChange("fromDate", fromDate);
          handleFilterChange("toDate", toDate);
          }}
        />

        <Col
          span={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            style={{height: 35.19}}
            block
          >
            Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
      @media (min-width: 768px) {
  :where(.css-dev-only-do-not-override-1j5i8gz).ant-col-md-4 {
    max-width: none !important;
    flex: none !important;
  }
}

  `}</style>
    </Card>
  );
};

export default FixedAssetLedgerFilters;
